import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
//import {LoginEntity} from "../home/domain/entities/login.entity";
import { AuthService } from './auth.service';
//import { IsLoginUsecase } from '../home/domain/usecases/auth_islogin.usecase';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
      //  private isLoginUsecase: IsLoginUsecase,
        private authService: AuthService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // var currentUser:Boolean= true;    
        // this.isLoginUsecase.execute(null).subscribe(value=>{
        //     currentUser= value;
        //   });
        if (this.authService.isLogin()) 
            // logged in so return true            
            return true;
        
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}